import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Input from '../shared/Input';
import SelectDropdown from '../../Components/shared/SelectDropdown'
import { fetchData, fetchFormData, getValueLabel } from '../../utils/options';
import topTost from '../../utils/topTost';
const DistrictCreate = () => {
    const { id } = useParams(); // to check if we're in edit mode
    const navigate = useNavigate();
    const [selectedOption, setSelectedOption] = useState(null);
    const [district, setDistrict] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [stateData, setStateData] = useState([]);


    const handleStateChange = (selectedState) => {
        if (selectedState) {
            const stateId = selectedState.value;
            setSelectedOption(stateId)
        }
    };


    const fetchDetails = async (id) => {
        try {
            const result = await fetchData(`district/details/${id}`, {}, 'POST');

            if (result && result.district) {

                setDistrict(result.district.district_title);
                setSelectedOption(Number(result.district.state_id));

            } else {
                console.warn('State data not found.');
                setDistrict('');
            }
        } catch (error) {
            console.error('Failed to fetch user details:', error);
            setDistrict('');
        }
    };


    const fetchAllData = async () => {
        const stateData = await fetchData("active-states");

        // Handle State Data
        if (stateData) {
            const states = stateData.states;
            setStateData(getValueLabel(states, "state_title", "state_id") || []);
        }
    };


    useEffect(() => {
        fetchAllData();
        if (id) {
            fetchDetails(id);
        }
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        // Construct FormData for district
        const formData = new FormData();
        formData.append("district_title", district);
        formData.append("district_description", district);
        formData.append("state_id", selectedOption);
        formData.append("status", 1);

        try {
            let res;

            if (id) {
                formData.append("id", id);
                // Edit district
                res = await fetchFormData('district/update', formData, "POST");
            } else {
                // Create new district
                res = await fetchFormData("add-district", formData, "POST");
            }

            if (res?.message === 'District inserted successfully' || res?.message === 'District updated successfully') {
                topTost({
                    title: res.message,
                    icon: "success",
                });
                navigate("/master/district-list");
            } else {
                topTost({
                    title: res?.message || "Operation failed",
                    icon: "error",
                });
            }
        } catch (error) {
            console.error("Submit error:", error);
            topTost({
                title: "Something went wrong",
                icon: "error",
            });
        } finally {
            setIsSubmitting(false);
        }
    };


    return (
        <>

            <div className="col-lg-12">
                <div className="card stretch stretch-full">
                    <hr className="mt-0" />
                    <div className="card-body general-info">
                        <div className="mb-5 d-flex align-items-center justify-content-between">
                            <h5 className="fw-bold mb-0 me-4">
                                <span className="d-block mb-2">{id ? 'Edit District:' : 'Add District:'}</span>
                            </h5>
                        </div>

                        <form onSubmit={handleSubmit} className="row g-3">

                            <div className="row">
                                <div className="col-lg-2">
                                    <label className="fw-semibold">State:<span className="text-danger">*</span> </label>
                                </div>
                                <div className="col-lg-4">
                                    <SelectDropdown
                                        options={stateData}
                                        selectedOption={stateData.find(opt => opt.value === Number(selectedOption)) || null}
                                        defaultSelect={"Select State"}
                                        onSelectOption={handleStateChange}
                                        value={selectedOption}
                                        icon="feather-map-pin"
                                    />
                                </div>

                                <div className='col-lg-6'>

                                    <Input
                                        icon='feather-map-pin'
                                        label={"District"}
                                        labelId={"districtInput"}
                                        placeholder={"District"}
                                        name={"district"}
                                        value={district}
                                        onChange={(name, value) => setDistrict(value)}
                                    />
                                </div>
                            </div>


                            <div className="mt-5 customButton">
                                <button type="submit" className="btn btn-lg btn-primary" disabled={isSubmitting}>
                                    {isSubmitting ? 'Submitting...' : id ? 'Update' : 'Submit'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DistrictCreate;
